import { Button as ButtonComponent, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const NoVouchersWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding-bottom: ${Spacing.S40};
  text-align: center;
`

export const Button = styled(ButtonComponent)`
  margin-top: ${Spacing.S16};
`

export const VouchersActionsWrapper = styled.section`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: ${Spacing.S16};
  padding: 0 ${Spacing.S16};
`
